import React, { useEffect, useMemo, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import RechargePenaltyReportTable from './rechargePenalityTable'
import { connect } from 'react-redux'
import { getRechargePenaltyReportData, getOwnChildBranches } from '../../../../store/reports/reports_action'
import moment from 'moment'
import { focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { getCityList, updateAlertError } from '../../../../store/common/common_action'
import RechargePenaltyReportTableForSTA from './RechargePenaltyReportTableForSTA'
import { GetRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { headerColumnRechargePenalty, headerColumnRechargePenaltyForSTA, headerFilterColumnRechargePenalty } from '../common/reportConstants'
import { STA_COMPANY_ID } from '../../../../helper/companyIdhardcode'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadPDF } from '../analysisReport/pdfAutotable'
const RechargePenaltyReport = (props) => {
    const { data: { common, reports }, getRechargePenaltyReportData, updateAlertError, getOwnChildBranches, getCityList } = props
    const { loginData: commonLoginData, cityList = [] } = common
    const { rechargePenaltyReportData, ownChildBranches = [] } = reports
    const [searchParams] = useSearchParams()
    const { loginData: tokenLoginData } = useToken()
    const { loginData, isFromUrl } = useMemo(() => {
        const hasUrlLoginData = Boolean(searchParams.get('C'))
        const sessionLoginData = tokenLoginData || commonLoginData
        if (!hasUrlLoginData && sessionLoginData && !isEmpty(sessionLoginData)) {
            return { loginData: sessionLoginData, isFromUrl: false }
        }
        return {
            loginData: {
                intCompanyID: Number(searchParams.get('C')) || 0,
                intBranchCityID: Number(searchParams.get('CT')) || 0,
                strCityName: searchParams.get('CTN') || '',
                intUserID: Number(searchParams.get('U')) || 0,
                intBranchID: Number(searchParams.get('B')) || 0,
                strCompanyName: searchParams.get('CN') || '',
                strUserName: searchParams.get('UN') || '',
                strBranchName: searchParams.get('BN') || '',
                IsBranchAdmin: Number(searchParams.get('IBA')) || 0,
                IsMTPLAdmin: Number(searchParams.get('IMPTLA')) || 0,
                IsAdmin: Number(searchParams.get('IA')) || 0,
            },
            isFromUrl: true,
        }
    }, [tokenLoginData, commonLoginData, searchParams])
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [showReport, setShowReport] = useState(false)
    const [sourceBranchData, setSourceBranchData] = useState(ownChildBranches || [])
    const [sourceCityData, setSourceCityData] = useState([])
    const [sourceCity, setSourceCity] = useState([])
    const [sourceBranch, setSourceBranch] = useState([])
    const [tableData, setTableData] = useState([])
    const [reportData, setReportData] = useState([]);
    const setAlert = useSetAtom(alertAtom)
    const setLoader = useSetAtom(globalLoaderAtom)
    const isSTACompany = Number(loginData?.intCompanyID) === STA_COMPANY_ID

    useEffect(() => {
        // Add 'All' option to city list with id 0, only if the city list is not empty or already has the option
        if (cityList.length > 0) {
            const cityListWithAll = [{ CityID: 0, CityName: 'All' }, ...cityList];
            setSourceCityData(cityListWithAll)
            setSourceCity({ CityID: loginData?.intBranchCityID, CityName: loginData?.strCityName });  // Update the state with the new city list
        }

        if (ownChildBranches?.length > 0) {
            const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...ownChildBranches];
            // Filter the branch list to include only branches matching loginData?.intBranchCityID
            const filteredBranchList = branchListWithAll.filter(branch =>
                Number(branch.CityID) === Number(loginData?.intBranchCityID)
            );
            setSourceBranchData(filteredBranchList)
            //  setSourceBranchData(branchListWithAll);  // Update the state with the new branch list
            setSourceBranch({ BranchID: loginData?.intBranchID, BranchName: loginData?.strBranchName })
        }
    }, [cityList, ownChildBranches]);

    useEffect(() => {
        if (!isEmpty(loginData)) {
            getCityList(loginData)
            const branchData = {
                intUserID: 0,
                intCompanyID: loginData?.intCompanyID,
                intIsActive: 1,
            }
            getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
        }
    }, [loginData])
    useEffect(() => {
        if (rechargePenaltyReportData?.length > 0) {
            let data = rechargePenaltyReportData.map((item, index) => ({
                ...item,
                sn: index + 1,
                RechargeRequestDate: item?.RechargeRequestDate === '' ? '' : moment(item.RechargeRequestDate).format('DD MMM YYYY, HH:mm'),
                AcceptDateTime: item?.AcceptDateTime === '' ? '' : moment(item.AcceptDateTime).format('DD MMM YYYY, HH:mm'),
            }));
            setTableData(data)
            setReportData(data)
        } else {
            setTableData([])
            setReportData([])
        }
    }, [rechargePenaltyReportData])
    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
    // const generateReport = () => {
    //     setShowReport(true)
    //     if (sourceCity == '' || sourceCity == ' ') {
    //         updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    //     } else if (sourceBranch == "" || sourceBranch == ' ') {
    //         updateAlertError({ show: true, msg: 'Select Branch', nextId: '' })
    //     } else {
    //         const obj = {
    //             CompanyID: loginData?.intCompanyID,
    //             CityID: sourceCity?.CityID,
    //             BranchID: sourceBranch?.BranchID,
    //             FromDate: moment(fromDate).format('YYYY-MM-DD'),
    //             ToDate: moment(toDate).format('YYYY-MM-DD'),
    //         }
    //         getRechargePenaltyReportData(obj)
    //     }
    // }


      const filterData = {
        FromDate: moment(fromDate).format('DD-MMM-YYYY'),
        ToDate: moment(toDate).format('DD-MMM-YYYY'),
        City: sourceCity?.CityName,
        Branch: sourceBranch?.BranchName,
        dataType: 'entry',
      }

      const generateReport = (isPdf = false) => {
        if (sourceCity == '' || sourceCity == ' ') {
          setAlert({ show: true, msg: 'Select City', nextId: '' })
          return
        } else if (sourceBranch == '' || sourceBranch == ' ') {
          setAlert({ show: true, msg: 'Select Branch', nextId: '' })
          return
        }
        setLoader(true)
        const obj = {
          CompanyID: loginData?.intCompanyID,
          CityID: sourceCity?.CityID,
          BranchID: sourceBranch?.BranchID,
          FromDate: moment(fromDate).format('YYYY-MM-DD'),
          ToDate: moment(toDate).format('YYYY-MM-DD'),
        }
        GetRequest(urls.getRechargePenaltyReportData, obj)
          .then((res) => {
            if (res.status !== 'Success') {
              throw new Error(res?.ErrMessage || 'Request Failed')
            }
            if (!Array.isArray(res?.Table) || res?.Table.length === 0) {
              throw new Error('No Data Found')
            }
            let updatedData = res?.Table.map((item, index) => ({
              ...item,
              SN: index + 1,
              dataType: 'entry',
            }))

            const reportPayload = {
              reportName,
              criteriaHeaders: headerFilterColumnRechargePenalty,
              criteriaData: [filterData],
              tableData: updatedData,
              mainHeader: isSTACompany ? headerColumnRechargePenaltyForSTA : headerColumnRechargePenalty,
              isShowManageColumn: false,
              manageColumnID: '',
              hideHeader: false,
              serialNokey: 'SN',
            }
            if (isPdf === true) {
              downloadPDF({
                reportName,
                criteriaHeaders: headerFilterColumnRechargePenalty,
                criteriaData: [filterData],
                tableData: updatedData,
                visibleColumns: isSTACompany ? headerColumnRechargePenaltyForSTA : headerColumnRechargePenalty,
                loginData,
                hideHeader: false,
                serialNokey: 'SN',
              })
              return
            }
            const rid = Date.now().toString()
            if (!window.generatedReports) {
              window.generatedReports = {}
            }
            window.generatedReports[rid] = reportPayload
            window.open(`/view-report?rid=${rid}`, '_blank')
          })
          .catch((err) => {
            setAlert({ show: true, msg: err.message, nextId: '' })
          })
          .finally(() => setLoader(false))
      }

    const selectedSourceCity = (obj) => {
        setShowReport(false)
        setSourceCity(obj)
        if (obj?.CityID === 0) {
            const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...ownChildBranches];
            setSourceBranchData(branchListWithAll);
            setSourceBranch(branchListWithAll[0])
        } else {
            const filteredBranches = ownChildBranches?.filter((val) => val.CityID === obj?.CityID);
            const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...filteredBranches];
            setSourceBranchData(branchListWithAll);
            setSourceBranch(branchListWithAll[0])
        }
    }
    const reportName = 'Failed Transactions Penalty'
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
                {!isFromUrl && <ReportHeading reportName={reportName} />}
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
                    {!isFromUrl && <>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            // id={id.selectCompnay}
                            label={"Select Company"}
                            defaultvalue={loginData.strCompanyName}
                            disabled={true}
                            // onSelect={(val) => setSelCompany(val)}
                            width="300px"
                        />{' '}
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary" >
                            GO
                        </Button>
                    </Item>
                    </>}
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={`From Transaction Date`}
                            name={'from_date'}
                            value={fromDate}
                            id={'fromDate'}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt('toDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={isFromUrl ? { ...sx.itemsxGrow, width: '60%' } : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={'To Transaction Date'}
                            name={'to_date'}
                            value={toDate}
                            id={'toDate'}
                            dateChange={(date) => {
                                setToDate(date)
                                focusElemnt('goButtonDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    {/* <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            id={'goButtonDate'}
                            onClick={handleGoClick}
                            onKeyDown={(e) => { navigation3(e, 'selectedCity', 'toDate', () => handleGoClick()) }}
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            className="btn btn-primary"
                        >
                            GO
                        </Button>
                    </Item> */}
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsxGrow}>
                        <DropDownOA
                            label={`Select City`}
                            id={'selectedCity'}
                            data={sourceCityData || []}
                            defaultvalue={sourceCity?.CityName || sourceCity}
                            dataKey={`CityName`}
                            idKey={`CityID`}
                            onSelect={(obj) => { selectedSourceCity(obj) }}
                            width="100%"
                            nextId={'selectedBranch'}
                            prevId={'goButtonDate'}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsxGrow}>
                        <DropDownOA
                            id={'selectedBranch'}
                            label={'Select Branch'}
                            data={sourceBranchData || []}
                            defaultvalue={sourceBranch?.BranchName || sourceBranch}
                            dataKey={`BranchName`}
                            idKey={`BranchID`}
                            onSelect={(val) => { setShowReport(false); setSourceBranch(val) }}
                            onReset={() => setSourceBranch('')}
                            nextId={'generateButton'}
                            prevId={'selectedCity'}
                            width="100%"
                        />
                    </Item>
                    {isFromUrl ?
                    <Button variant="contained" sx={{ width: '100%', height: '40px', marginBottom:'10px' }} className="btn btn-primary" onClick={() => generateReport(true)} id={'generateButton'}>
                        DOWNLOAD PDF
                    </Button> :
                    <Item sx={sx.itemsx}
                        onKeyDown={(e) => { navigation3(e, showReport ? "ExpToExlbtn" : 'fromDate', 'selectedBranch', () => generateReport()) }}
                    >
                        {/* <SplitButton
                            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                            // hideToggle={false}
                            id1={'generateButton'}
                            onClick1={generateReport}
                        // onClick2={handleClick2}
                        /> */}
                        {!isSTACompany ?
                            <SplitButton
                                options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                                hideToggle={false}
                                onClick1={() => { generateReport() }}
                                // onClick2={handleClick2}
                                id1={'bdtSplitButton'}
                                prevID={'bdtTransactionType'}
                            /> :
                            <Button
                                variant="contained"
                                id='bdtSplitButton'
                                style={{ ...sx.fullHeight, ...sx.novp }}
                                className="btn btn-primary"
                                onClick={() => generateReport()}
                                onKeyDown={(e) => { navigation3(e, '', 'bdtTransactionType', () => { generateReport() }) }}
                            >
                                GENERATE NEW FORMAT
                            </Button>
                        }
                    </Item>
                    }
                </Box>
            </Item>
            {
                showReport ? isSTACompany ? <RechargePenaltyReportTableForSTA tableData={tableData?.map((val, index) => ({ ...val, SN: index + 1, PenaltyDate: val?.PenaltyDate === '' ? '' : moment(val?.PenaltyDate).format('DD-MMM-YYYY') }))} loginData={loginData} sourceCity={sourceCity} sourceBranch={sourceBranch} fromDate={fromDate} toDate={toDate} setTableData={setTableData} reportData={reportData} /> : <RechargePenaltyReportTable tableData={tableData} loginData={loginData} sourceCity={sourceCity} sourceBranch={sourceBranch} fromDate={fromDate} toDate={toDate} setTableData={setTableData} reportData={reportData} /> : ''
            }
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getRechargePenaltyReportData, updateAlertError, getOwnChildBranches, getCityList }
export default connect(mapStateToProps, mapDispatchToProps)(RechargePenaltyReport)
